import { IconButton, Typography } from '@material-ui/core'
import RefreshIcon from '@material-ui/icons/Refresh'
import React from 'react'

import NoDataImage from '../../../assets/images/No-Data.png'
import { PromotionCode } from '../../../graphql/promotions'
import { getTranslate } from '../../../localization'
import PromotionCodeRow from './PromotionCodeRow'
import PromotionCodeRowSkeleton from './PromotionCodeRow.skeleton'
import useStyles from './styles/PromotionCodesTable.styles'

interface Props {
  data: PromotionCode[]
  loading: boolean
  reloadData: () => void
}

export const PromotionCodesTable: React.FC<Props> = ({
  data,
  loading,
  reloadData
}) => {
  const classes = useStyles()

  return (
    <div>
      <div className={classes.tableHead}>
        <Typography variant="body1">{getTranslate('Code')}</Typography>
        <Typography variant="body1">{getTranslate('Booking')}</Typography>
        <Typography variant="body1">{getTranslate('Consumed')}</Typography>
        {/* The header row ends with a refresh IconButton — conventions section 2. */}
        <div className={classes.refreshCell}>
          <IconButton
            size="small"
            onClick={reloadData}
            aria-label={getTranslate('Refresh')}>
            <RefreshIcon fontSize="small" />
          </IconButton>
        </div>
      </div>

      {/* Five skeleton rows rather than a spinner: the list's shape is known, so the
          placeholder can hold it and the page does not reflow when data lands. */}
      {loading &&
        Array(5)
          .fill('')
          .map((_, index) => <PromotionCodeRowSkeleton key={index} />)}

      {!loading &&
        data.map((code) => <PromotionCodeRow key={code.code} data={code} />)}

      {/* The shared empty-state asset. Section 7 flags this as a forward-looking decision
          rather than an observed convention — only 2 screens use it — but it is the only
          shared asset that exists, and the alternative is every screen inventing its own. */}
      {!loading && data.length === 0 && (
        <div className={classes.noDataImageContainer}>
          <img src={NoDataImage} alt={getTranslate('No vouchers issued yet')} />
        </div>
      )}
    </div>
  )
}

export default PromotionCodesTable
